import React, { useState, useEffect } from 'react';
import { Card, Form, Button, Row, Col, Spinner } from '@themesberg/react-bootstrap';
import api from '../../utils/api';
import Select from 'react-select';

export default () => {
  const [loading, setLoading] = useState(false);
  const [saveSuccess, setSaveSuccess] = useState(false);
  const [fakeAccounts, setFakeAccounts] = useState([]);
  
  const [likeListSettings, setLikeListSettings] = useState({
    enabled: true,
    activeFakeIds: [],
    minIntervalMinutes: 5,
    maxIntervalMinutes: 15,
    minDailyLimit: 2,
    maxDailyLimit: 4
  });

  useEffect(() => {
    loadFakeAccounts();
    loadLikeListSettings();
  }, []);

  const loadFakeAccounts = async () => {
    try {
      const response = await api.get('/users?isTestUser=true&limit=500');
      const users = response.data?.users || [];
      setFakeAccounts(users.map(user => ({
        value: user.uid || user.id,
        label: user.name || user.displayName || user.firstName || 'Bilinmeyen'
      })));
    } catch (err) {
      console.error('Error loading fake accounts:', err);
    }
  };

  const loadLikeListSettings = async () => {
    try {
      const response = await api.get('/settings/likeList');
      const data = response.data?.value || response.data;
      if (!data || data === null) return;

      setLikeListSettings({
        enabled: data.enabled !== false,
        activeFakeIds: Array.isArray(data.activeFakeIds) ? data.activeFakeIds : [],
        minIntervalMinutes: data.minIntervalMinutes || 5,
        maxIntervalMinutes: data.maxIntervalMinutes || 15,
        minDailyLimit: data.minDailyLimit || 2,
        maxDailyLimit: data.maxDailyLimit || 4
      });
    } catch (err) {
      console.error('Error loading like list settings:', err);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setLikeListSettings(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : (parseFloat(value) || 0)
    }));
  };

  const handleFakeAccountChange = (selectedOptions) => {
    const ids = selectedOptions ? selectedOptions.map(option => option.value) : [];
    setLikeListSettings(prev => ({
      ...prev,
      activeFakeIds: ids
    }));
  };

  const handleSaveSettings = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      setSaveSuccess(false);
      await api.post('/settings/update', { likeList: likeListSettings });
      setSaveSuccess(true);
      setTimeout(() => setSaveSuccess(false), 3000);
    } catch (err) {
      console.error('Error saving like list settings:', err);
      alert('Ayarlar kaydedilirken bir hata oluştu.');
    } finally {
      setLoading(false);
    }
  };

  const selectedOptions = fakeAccounts.filter(account => 
    likeListSettings.activeFakeIds.includes(account.value)
  );

  return (
    <>
      <div className="d-xl-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-xl-0">
          <h4>Beğeni Listesi (Like List) Ayarları</h4>
          <p className="mb-0">
            Kullanıcılara otomatik olarak gönderilecek etkileşimleri (Beğeni, Profile Bakma, Şehirden Eşleşme) buradan ayarlayın.
          </p>
        </div>
      </div>

      <Row>
        <Col xs={12} xl={8}>
          <Card border="light" className="bg-white shadow-sm mb-4">
            <Card.Body>
              <Form onSubmit={handleSaveSettings}>
                <Form.Check
                  type="switch"
                  id="likeListEnabled"
                  className="mb-4"
                  label="Beğeni / Like List sistemi aktif"
                  name="enabled"
                  checked={!!likeListSettings.enabled}
                  onChange={handleChange}
                />

                <h5 className="mb-4">Hesap ve Havuz Seçimi</h5>
                
                <Form.Group className="mb-4">
                  <Form.Label>Havuzdaki Fake Hesaplar</Form.Label>
                  <Select
                    isMulti
                    options={fakeAccounts}
                    value={selectedOptions}
                    onChange={handleFakeAccountChange}
                    placeholder="Görev alacak fake hesapları seçin..."
                    noOptionsMessage={() => "Hesap bulunamadı"}
                  />
                  <Form.Text className="text-muted">
                    Bu listeye eklenen profiller kullanıcılara bildirim atmak için sırayla kullanılacaktır.
                  </Form.Text>
                </Form.Group>

                <h5 className="mb-3 mt-5">Zamanlama Ayarları</h5>
                <Row>
                  <Col md={6} className="mb-3">
                    <Form.Group id="minIntervalMinutes">
                      <Form.Label>Minimum Bekleme (Dakika)</Form.Label>
                      <Form.Control 
                        required 
                        type="number" 
                        name="minIntervalMinutes"
                        value={likeListSettings.minIntervalMinutes}
                        onChange={handleChange}
                        min="1"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6} className="mb-3">
                    <Form.Group id="maxIntervalMinutes">
                      <Form.Label>Maksimum Bekleme (Dakika)</Form.Label>
                      <Form.Control 
                        required 
                        type="number" 
                        name="maxIntervalMinutes"
                        value={likeListSettings.maxIntervalMinutes}
                        onChange={handleChange}
                        min="1"
                      />
                    </Form.Group>
                  </Col>
                </Row>
                
                <h5 className="mb-3 mt-4">Günlük Limit Ayarları</h5>
                <p className="text-muted small mb-3">Sistemin robotik hissettirmemesi için kullanıcılara günlük belirli bir aralıkta etkileşim gider.</p>
                <Row>
                  <Col md={6} className="mb-3">
                    <Form.Group id="minDailyLimit">
                      <Form.Label>Günlük Minimum Etkileşim Kotası</Form.Label>
                      <Form.Control 
                        required 
                        type="number" 
                        name="minDailyLimit"
                        value={likeListSettings.minDailyLimit}
                        onChange={handleChange}
                        min="1"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6} className="mb-3">
                    <Form.Group id="maxDailyLimit">
                      <Form.Label>Günlük Maksimum Etkileşim Kotası</Form.Label>
                      <Form.Control 
                        required 
                        type="number" 
                        name="maxDailyLimit"
                        value={likeListSettings.maxDailyLimit}
                        onChange={handleChange}
                        min="1"
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <div className="mt-4">
                  <Button variant="primary" type="submit" disabled={loading}>
                    {loading ? <Spinner animation="border" size="sm" /> : "Ayarları Kaydet"}
                  </Button>
                  {saveSuccess && (
                    <span className="text-success ms-3 fw-bold">Ayarlar başarıyla kaydedildi!</span>
                  )}
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
        
        <Col xs={12} xl={4}>
          <Card border="light" className="bg-white shadow-sm mb-4">
            <Card.Header>
              <h5 className="mb-0">Algoritma Nasıl Çalışır?</h5>
            </Card.Header>
            <Card.Body>
              <p className="small">1. Sistem havuza eklediğiniz fake hesapların içerisinden hiç kullanılmamış olanı rastgele seçer.</p>
              <p className="small">2. Belirttiğiniz <strong>Min</strong> ve <strong>Maks</strong> dakika değerleri arasında rastgele bir süre (örn: 12 dk) kurarak arka planda sessiz bir zamanlayıcı başlatır.</p>
              <p className="small">3. Süre dolduğunda seçilen etiket zorunlu diziye göre ("Şehirden Eşleşme", "Profiline Baktı", "Seni Beğendi") kullanıcıya gönderilir ve günlük hedeflenen kotadan düşülür.</p>
              <p className="small text-danger fw-bold">Not: Kullanıcı limiti veya hesabın havuz limiti dolar ve yeni fake hesap kalmazsa algoritma durur. Listeye yeni kişiler eklendiğinde kaldığı diziden / etiketten devam eder.</p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};
